import type { IRsvpAdditionalGuest, RsvpStatus } from "./rsvp"

export interface IGuestResponse {
  GuestID: number
  Name: string
  Email: string
  PicsCount: number
  VidsCount: number
  MessagesCount: number
}

export interface IGuestResponseV1 {
  eventGuestId: number
  name: string
  email: string
  picsCount: number
  vidsCount: number
  messagesCount: number
  uploadRestricted?: boolean
  isBlocked?: boolean
  additionalGuests?: IRsvpAdditionalGuest[]
  rsvpDetails?: {
    rsvpStatus?: RsvpStatus
    guestRSVPComment?: string
    dietaryRequirements?: string
    songRequests?: string
    guestCount?: number
    rsvpUpdatedDate?: Date
  }
}

export class Guest {
  public id?: number
  public name?: string
  public email?: string
  public picsCount: number = 0
  public vidsCount: number = 0
  public messagesCount: number = 0
  public uploadRestricted?: boolean
  public isBlocked?: boolean
  public additionalGuests?: IRsvpAdditionalGuest[]
  public rsvpStatus?: RsvpStatus
  public rsvpComment?: string
  public dietaryRequirements?: string
  public songRequests?: string
  public rsvpCount?: number
  public rsvpUpdatedDate?: Date

  constructor(guest: Partial<Guest>) {
    this.id = guest.id
    this.name = guest.name
    this.email = guest.email
    this.picsCount = guest.picsCount ?? 0
    this.vidsCount = guest.vidsCount ?? 0
    this.messagesCount = guest.messagesCount ?? 0
    this.uploadRestricted = guest.uploadRestricted
    this.isBlocked = guest.isBlocked
    this.additionalGuests = guest.additionalGuests
    this.rsvpStatus = guest.rsvpStatus
    this.rsvpComment = guest.rsvpComment
    this.dietaryRequirements = guest.dietaryRequirements
    this.songRequests = guest.songRequests
    this.rsvpCount = guest.rsvpCount
    this.rsvpUpdatedDate = guest.rsvpUpdatedDate
  }

  public static fromResponse(response: IGuestResponse) {
    return new Guest({
      id: response.GuestID,
      name: response.Name,
      email: response.Email,
      picsCount: response.PicsCount,
      vidsCount: response.VidsCount,
      messagesCount: response.MessagesCount,
    })
  }

  public static fromResponseV1(response: IGuestResponseV1) {
    return new Guest({
      id: response.eventGuestId,
      name: response.name,
      email: response.email,
      picsCount: response.picsCount,
      vidsCount: response.vidsCount,
      messagesCount: response.messagesCount,
      uploadRestricted: response.uploadRestricted,
      isBlocked: response.isBlocked,
      additionalGuests: response.additionalGuests,
      rsvpStatus: response.rsvpDetails?.rsvpStatus,
      rsvpComment: response.rsvpDetails?.guestRSVPComment,
      dietaryRequirements: response.rsvpDetails?.dietaryRequirements,
      songRequests: response.rsvpDetails?.songRequests,
      rsvpCount: response.rsvpDetails?.guestCount,
      rsvpUpdatedDate: response.rsvpDetails?.rsvpUpdatedDate,
    })
  }
}
